import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "@/components/ui/library/card";
import { useCourseForm } from "@/features/universityAndCourse/contexts/FormCourseContext";
import useSpesificCustoms from "@/features/customField/api/useSpesificCustoms";
import { getCfDisplayName } from "@/features/customField/utils/cfDisplayName";
import { course_spesific_key } from "@/config/endpoints";
import { Controller, useWatch } from "react-hook-form";
import { Coins } from "lucide-react";
import { useEffect } from "react";

export default function RevenueCommissions() {
  const { control, getValues, setValue } = useCourseForm();

  const { spesificFields, isLoading } = useSpesificCustoms({
    queryKey: course_spesific_key,
    modelName: "course",
  });

  const numberFields = spesificFields?.filter((f: any) => f.type === "NUMBERS");

  const customInputScopes =
    useWatch({ control, name: "customInputScopes" }) ?? [];

  useEffect(() => {
    if (!numberFields?.length) return;
    const currentScopes = getValues("customInputScopes") ?? [];

    let changed = false;
    const updated = [...currentScopes];

    for (const field of numberFields) {
      const exists = updated.some(
        (s: any) => Number(s?.customInputId) === Number(field.id)
      );
      if (!exists) {
        updated.push({ customInputId: field.id, optionIds: [], textValue: "" });
        changed = true;
      }
    }

    if (changed) setValue("customInputScopes", updated);
  }, [numberFields, getValues, setValue]);

  if (isLoading || !numberFields?.length) return null;

  return (
    <Card className="bg-white border-[#e6e8e7] w-full gap-4 p-4">
      <CardHeader className="px-0 py-0 gap-0">
        <div className="flex items-center gap-2">
          <div className="size-7 rounded-lg bg-[#FFF8E1] flex items-center justify-center shrink-0">
            <Coins className="size-4 text-[#F9A825]" strokeWidth={1.8} />
          </div>
          <CardTitle className="font-medium text-base text-black tracking-[-0.32px]">
            Revenue & Commissions
          </CardTitle>
        </div>
      </CardHeader>

      <CardContent className="px-0 py-0">
        <div className="flex flex-col gap-3 pl-2 w-full">
          {numberFields.map((field: any) => {
            const scopeIndex = customInputScopes.findIndex(
              (s: any) => Number(s?.customInputId) === Number(field.id)
            );

            if (scopeIndex === -1) return null;

            return (
              <div key={field.id} className="flex flex-col gap-1.5 w-full">
                <Label className="text-[#051912] text-sm tracking-[-0.56px] font-normal leading-[1.35]">
                  {getCfDisplayName(field)}{" "}
                  <span className="text-[#505e59]">(per application)</span>
                </Label>
                <Controller
                  name={`customInputScopes.${scopeIndex}.textValue`}
                  control={control}
                  render={({ field: formField }) => (
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-[#9ba3a0]">
                        ₹
                      </span>
                      <Input
                        type="number"
                        min={0}
                        placeholder="Eg. 50000"
                        value={formField.value || ""}
                        onChange={(e) => formField.onChange(e.target.value)}
                        className="bg-[#fcfcfc] border-[#cdd1d0] h-10 rounded-xl pl-7 pr-3 py-2 text-sm text-[#505e59] tracking-[-0.56px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      />
                    </div>
                  )}
                />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
